/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InProgress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InProgress({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/EditAction/Content/Edit/Content/InProgress"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesInprogressValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.inprogress',
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="InProgress.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-KG3e1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="In-progress coverage"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsBlack}
 text={insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesInprogressValueData ? "Yes" : "No"}
 data="insurance.insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.inprogress"
/>
</div>
{children}
</React.Fragment>)
}